import './ShareLink.scss';
import { ShareLink as FrShareLink } from 'festo-react-ui-kit';
import React from 'react';
import { econdaClickEvent } from '../../Econda';

import useTranslation from '../../features/translation/hooks/useTranslation';

enum TranslationKeys {
  SHARE = 'resultShare',
  COPY = 'resultCopy',
  COPIED = 'resultCopied',
}

const ShareLink: React.FC = () => {
  const t = useTranslation();

  function onClick() {
    econdaClickEvent('cta buttons', 'general', 'share', 'share');
  }
  function onClose() {
    econdaClickEvent('cta buttons', 'general', 'share', 'close');
  }
  function onOk() {
    econdaClickEvent('cta buttons', 'general', 'share', 'copy link');
  }

  return (
    <FrShareLink
      data-testid="share-link"
      copiedText={t(TranslationKeys.COPIED)}
      copyText={t(TranslationKeys.COPY)}
      shareText={t(TranslationKeys.SHARE)}
      onLinkClick={onClick}
      onOk={onOk}
      onClose={onClose}
    />
  );
};

export default ShareLink;
